import { useActivityFilterOptions } from '../../hooks/useActivities';
import ToggleChipGroup from '../spark-activities/ToggleChipGroup';

type TagField = 'playTypeIds' | 'preferenceIds' | 'physicalDeckIds';

interface ActivitySharedTagsProps {
  playTypeIds: number[];
  preferenceIds: number[];
  physicalDeckIds: number[];
  onChange: (field: TagField, ids: number[]) => void;
  readOnly?: boolean;
}

export default function ActivitySharedTags({
  playTypeIds,
  preferenceIds,
  physicalDeckIds,
  onChange,
  readOnly,
}: ActivitySharedTagsProps) {
  const { data: options } = useActivityFilterOptions();

  const handle = (field: TagField) => (ids: number[]) => {
    if (!readOnly) onChange(field, ids);
  };

  return (
    <div
      data-testid="shared-tags"
      className={`bg-[#F4F9F6] border-[1.5px] border-pine-line rounded-[12px] p-[8px_20px_20px] ${
        readOnly ? 'opacity-70 pointer-events-none' : ''
      }`}
    >
      <p className="mt-[14px] text-[11px] font-bold uppercase tracking-[0.12em] text-pine-pine">
        Shared tags (same across all levels)
      </p>
      <div data-testid="play-style-section">
        <ToggleChipGroup
          label="Play style"
          items={options?.playTypes ?? []}
          selectedIds={playTypeIds}
          onChange={handle('playTypeIds')}
        />
      </div>
      <div data-testid="preferences-section">
        <ToggleChipGroup
          label="Preferences"
          secondaryLabel="What the child enjoys"
          items={options?.preferences ?? []}
          selectedIds={preferenceIds}
          onChange={handle('preferenceIds')}
        />
      </div>
      <div data-testid="physical-deck-section">
        <ToggleChipGroup
          label="Physical deck"
          items={options?.physicalDecks ?? []}
          selectedIds={physicalDeckIds}
          onChange={handle('physicalDeckIds')}
        />
      </div>
    </div>
  );
}
